import React from 'react';
import useGenericMutationUseCase from '../../../hooks/usecases/generic/useGenericMutationUseCase';
import { useDeleteContact } from '../../../services/api/generated/client';
import { ConfirmationModal } from '../ConfirmationModal/ConfirmationModal';
import { localise } from '../../../services/lang/lang';
export const DeleteContactModalWrapper = ({ contact, onClose, onSuccess, }) => {
    const useDeleteContactUseCase = useGenericMutationUseCase(useDeleteContact);
    const onConfirm = () => {
        useDeleteContactUseCase.execute({
            id: contact.id,
        }, undefined, {
            onSuccess,
        });
    };
    return (React.createElement(ConfirmationModal, { isOpen: true, title: localise('DELETE_CONTACT_MODAL_TITLE'), confirmText: localise('DELETE_CHALLENGE'), onClose: onClose, onConfirm: onConfirm, isLoading: false }, localise('DELETE_CONTACT_MODAL_MESSAGE')));
};
